var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1417 7.74279C17.057 3.69433 12.8956 1.29179 8.84717 2.37657C6.57426 2.98559 4.85034 4.55731 3.95619 6.54957L5.41062 6.15529C5.94367 6.01078 6.49293 6.32576 6.63743 6.8588C6.78194 7.39185 6.46696 7.94111 5.93392 8.08561L2.76354 8.94508C2.72816 8.95684 2.69201 8.96666 2.65526 8.97443L2.24955 9.08441C1.99309 9.15394 1.71949 9.11853 1.48918 8.98601C1.25886 8.85348 1.09076 8.63474 1.02198 8.37807L0.0339866 4.69081C-0.108955 4.15735 0.207627 3.60901 0.741094 3.46607C1.27456 3.32313 1.8229 3.63971 1.96584 4.17317L2.29228 5.39147C3.4594 3.04016 5.57207 1.18358 8.32953 0.444717C13.4449 -0.92595 18.7029 2.10976 20.0736 7.22516C20.2165 7.75862 19.9 8.30696 19.3665 8.4499C18.833 8.59284 18.2847 8.27626 18.1417 7.74279Z",
    fill: "#1A1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.b48aa9b8ec1cd002784eab69a875fb34.svg";
export { ForwardRef as ReactComponent };